import { useEffect, useLayoutEffect } from 'react'
import { focusTrap, getFocusable } from '~/utils'

const useFocusTrap = (containerRef, enabled = true) => {
  useLayoutEffect(() => {
    const container = containerRef?.current
    if (!container) return

    function handler(event) {
      if (!enabled) return
      if (event.key === 'Tab') {
        focusTrap(container, event)
      }
    }

    container.addEventListener('keydown', handler)
    return () => container.removeEventListener('keydown', handler)
  }, [containerRef, enabled])

  useEffect(() => {
    const intId = setTimeout(() => {
      if (!enabled) return
      const container = containerRef?.current
      if (!container) return

      if (container.contains(document.activeElement)) {
        return
      }

      const focusable = getFocusable(container)
      const firstFocusable = focusable.length ? focusable[0] : null
      if (firstFocusable) {
        if (typeof firstFocusable.select === 'function') {
          firstFocusable.select()
        } else {
          firstFocusable.focus()
        }
      }
    }, 100)
    return () => clearTimeout(intId)
  }, [containerRef, enabled])
}

export default useFocusTrap
